import ltsv_path from 'url:/models/ltsv/La_torre2k_jpg.glb';
import barco_path from 'url:/models/ltsv/Barco1k.glb';
import canyon_path from 'url:/models/ltsv/Canioon2k.glb';

function setUpViewer(id, path, exposure){
    let viewer = document.getElementById(id);
    if (!viewer) return;

    viewer.exposure = exposure;
    viewer.src = path;
}

setUpViewer('torre', ltsv_path, 1);
setUpViewer('canyon', canyon_path, 0.6);
setUpViewer('barco', barco_path, 0.6);